import * as Yup from "yup";

const yesterday = new Date();
yesterday.setDate(yesterday.getDate() - 2);
const fixedDate = new Date('2006-11-06');

export const inrixSchema = Yup.object().shape({
  startDate: Yup.date()
    .required('Start date is required')
    .max(yesterday, `Date can't be after (${yesterday.toLocaleDateString()})`)
    .min(fixedDate, `Date can't be before (${fixedDate.toLocaleDateString()})`),
  endDate: Yup
    .date()
    .required('End date is required')
    .max(yesterday, `Date can't be after (${yesterday.toLocaleDateString()})`)
    .min(fixedDate, `Date can't be before (${fixedDate.toLocaleDateString()})`)
    .when('startDate', (startDate, schema) =>
      startDate instanceof Date
        ? schema.min(startDate, 'End date must be after start date')
        : schema
    ),
  geoSpatialMatchOn: Yup.array().min(
    1,
    "At least one geospatial match option must be selected"
  ),
  endpointTypes: Yup.array().min(
    1,
    "At least one endpoint type must be selected"
  ),
  providerTypes: Yup.array().min(
    1,
    "At least one provider type must be selected"
  ),
  vehicleWeightClasses: Yup.array().min(
    1,
    "At least one vehicle weight class must be selected"
  ),
});
